import styled, { css } from 'styled-components';

export const opoCardStyles = css`
    border: 1px solid #E3E8EF;
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
`;

export const opoTableStyles = css`
    & > thead > tr > th {
        padding: 9px 8px 7px !important;
        vertical-align: middle !important;
        border: none !important;
        border-bottom: 1px solid #E3E8EF !important;
        background-color: #FAFBFC;
        color: #3A4756;
        font-size: 11px !important;
        font-weight: 600;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        line-height: 1.3;
        text-align: left;
    }

    & > tbody > tr > td {
        height: 44px;
        padding: 6px 8px !important;
        vertical-align: middle !important;
        border-top: 1px solid #EEF1F5 !important;
        border-right: none !important;
        color: #1F2A37;
        font-size: 13px !important;
        font-variant-numeric: tabular-nums;
        text-align: left;
    }

    & > tbody > tr:last-child > td {
        border-bottom: none !important;
    }

    & > tbody > tr:hover > td {
        box-shadow: inset 0 0 0 9999px rgba(16, 24, 40, 0.03);
    }

    & > tbody > tr > td > .btn-group {
        display: inline-flex;
        gap: 4px;
    }

    & > tbody > tr > td > .btn-group > .btn {
        float: none;
        min-width: 26px !important;
        height: 24px;
        margin-left: 0;
        padding: 0 7px !important;
        border-radius: 6px !important;
        font-size: 11px !important;
        font-weight: 600;
        line-height: 22px;
    }

    & > tbody > tr > td > .btn-group > .btn-default {
        border-color: #D5DBE3;
        color: #3A4756;
    }

    & > tbody > tr > td > .btn-group > .btn-default:hover {
        background-color: #F3F5F8;
    }

    @media (max-width: 1823px) {
        & > thead > tr > th {
            padding: 11px 6px 7px !important;
            font-size: 10px !important;
        }

        & > thead > tr > th.role {
            padding-left: 15px !important
        }

        & > tbody > tr > td {
            padding: 5px 6px !important;
            font-size: 12px !important;
        }
    }
`;

export const opoFormStyles = css`
    .control-label {
        display: block;
        margin-bottom: 3px;
        font-size: 12px;
        font-weight: 600;
        color: #3A4756;
        white-space: nowrap;
    }

    .form-control {
        height: 32px;
        padding: 0 10px;
        border: 1px solid #D5DBE3;
        border-radius: 8px;
        box-shadow: none;
        font-size: 13px;
        color: #1F2A37;
    }

    .form-control:focus {
        border-color: #337AB7;
        box-shadow: 0 0 0 3px rgba(51, 122, 183, 0.15);
    }
`;

export const opoSegmentedStyles = css`
    .segmented {
        display: inline-flex;
        gap: 2px;
        padding: 3px;
        border-radius: 9px;
        background: #DCE7F2;
        border: 1px solid #CBD9E8;
    }

    .segmented > .btn {
        height: 26px;
        min-width: 56px;
        padding: 0 12px;
        border: none;
        border-radius: 6px;
        background: transparent;
        color: #3A4756;
        font-size: 13px;
        font-weight: 500;
        box-shadow: none;
    }

    .segmented > .btn.active {
        background: #FFFFFF;
        color: #16365A;
        font-weight: 600;
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.10);
    }
`;

export const opoButtonStyles = css`
    .btn {
        height: 32px;
        padding: 0 14px;
        border-radius: 8px;
        border: 1px solid #D5DBE3;
        background: #FFFFFF;
        color: #1F2A37;
        font-size: 13px;
        font-weight: 500;
        white-space: nowrap;
    }

    .btn:hover {
        background: #F3F5F8;
    }

    .btn-primary {
        border-color: #337AB7;
        background: #337AB7;
        color: #FFFFFF;
        font-weight: 600;
    }

    .btn-primary:hover {
        background: #2B6CB0;
        border-color: #2B6CB0;
    }

    .btn-danger {
        border-color: #C9302C;
        background: #C9302C;
        color: #FFFFFF;
        font-weight: 600;
    }

    .btn-danger:hover {
        background: #AC2925;
        border-color: #AC2925;
    }
`;

export const FilterCard = styled.div`
    margin-bottom: 14px;
    padding: 12px 16px 14px;
    background: #fff;
    border: 1px solid #D3E0EE;
    border-radius: 12px;

    .search-row {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
        gap: 8px 12px;
    }

    .form-group {
        margin-bottom: 0;
    }

    ${opoFormStyles}

    .search-actions {
        display: flex;
        align-items: center;
        gap: 8px;

        ${opoButtonStyles}
    }

    .search-toggles {
        display: flex;
        gap: 2px;
        padding: 3px;
        border-radius: 9px;
        background: #DCE7F2;
        border: 1px solid #CBD9E8;
    }

    .search-toggles > .btn {
        height: 26px;
        padding: 0 12px;
        border: none;
        border-radius: 6px;
        background: transparent;
        color: #3A4756;
        font-size: 13px;
        font-weight: 500;
        box-shadow: none;
        white-space: nowrap;
    }

    .search-toggles > .btn.active {
        background: #FFFFFF;
        color: #16365A;
        font-weight: 600;
        box-shadow: 0 1px 2px rgba(16, 24, 40, 0.10);
    }

    .search-stats {
        display: flex;
        gap: 10px;
        margin-left: auto;
    }

    .search-stat {
        display: flex;
        flex-direction: column;
        justify-content: center;
        min-width: 110px;
        height: 48px;
        padding: 0 12px;
        border: 1px solid #D3E0EE;
        border-radius: 8px;
        background: #FFFFFF;
    }

    .search-stat > .k {
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        color: #6B7A8F;
        white-space: nowrap;
    }

    .search-stat > .v {
        font-size: 16px;
        font-weight: 700;
        color: #16365A;
        line-height: 1.2;
    }
`;

export const NoRows = styled.div`
    padding: 24px 0;
    color: #6B7A8F;
    font-size: 14px;
`;

export const OpoModalForm = styled.div`
    ${opoFormStyles}

    font-size: 14px;

    .control-label,
    .form-control {
        font-size: 14px;
    }

    .form-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 12px 16px;
    }

    .form-grid-mask {
        opacity: 0.35;
        filter: blur(1.5px);
        pointer-events: none;
        user-select: none;
    }

    .form-grid > .full-width {
        grid-column: 1 / -1;
    }

    .form-group {
        margin-bottom: 0;
    }

    .required {
        color: #A3201A;
    }

    .has-error .control-label {
        color: #A3201A;
    }

    .has-error .form-control,
    .has-error .form-control:focus {
        border-color: #A3201A;
    }

    .has-error .form-control:focus {
        box-shadow: 0 0 0 3px rgba(163, 32, 26, 0.18);
    }

    .help-block {
        margin: 4px 0 0;
        font-size: 14px;
        color: #A3201A;
    }

    .notice {
        margin-bottom: 16px;
        padding: 10px 14px;
        border: 1px solid #B9D3EE;
        border-left: 4px solid #337AB7;
        border-radius: 8px;
        background: #E8F1FB;
        font-size: 13px;
        font-weight: 500;
        color: #16365A;
    }

    ${opoSegmentedStyles}
`;

export const OpoModalButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;

    ${opoButtonStyles}

    .btn {
        font-size: 14px;
    }
`;
